import { fr } from './translations/fr';
import { en } from './translations/en';
import { es } from './translations/es';
import { ru } from './translations/ru';

const translations = {
  fr,
  en,
  es,
  ru
};

export type TranslationKey = keyof typeof fr;
export type Language = keyof typeof translations;

export function useTranslation(lang: Language) {
  return {
    t: (key: string) => {
      const keys = key.split('.');
      let value: any = translations[lang];
      
      for (const k of keys) {
        value = value?.[k];
      }
      
      return value || key;
    }
  };
}
